import { AbstractIconComponent } from '../abstract.icon'
import { Component } from '@angular/core'

@Component({
  selector: 'icon-ev-connector-cee-red',
  templateUrl: './ev-connector-cee-red.icon.html',
  styles: [
    `
      svg {
        width: 100px;
        height: 100px;
        padding-top: 20px;
      }
    `,
  ],
})
export class EvConnectorCeeRedComponent extends AbstractIconComponent {
  static icon = 'ev-connector-cee-red'
}
